/**
 * 関連付くマニフェスト
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest`

export default {
  namespaced: true,
  actions: {
    /**
     * 指定マニフェストに紐付くマニフェスト一覧
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    index ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}/relations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * マニフェストの関連付け
     * @param commit
     * @param id
     * @param params
     * @param manifest_ids
     * @return {Promise<unknown>}
     */
    update({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}/relations`
      return new Promise((resolve) => {
        Vue.$http.put(api_path, params).then(data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
}
